import type { SVGProps } from 'react';
const SvgIconFolder = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path fill="currentColor" d="M11.25 10a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.382 1.5a2.5 2.5 0 0 1 2.151 1.227l.085.155.309.618H12.5A2.5 2.5 0 0 1 15 6v6a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12V4a2.5 2.5 0 0 1 2.5-2.5zM3.5 3l-.103.005A1 1 0 0 0 2.5 4v8l.005.102a1 1 0 0 0 .892.893L3.5 13h9l.102-.005a1 1 0 0 0 .893-.893L13.5 12V6a1 1 0 0 0-.898-.995L12.5 5H8.618l-.14-.01a1 1 0 0 1-.683-.422l-.071-.12-.448-.895a1 1 0 0 0-.754-.543L6.382 3z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconFolder;
